<section class="relative bg-white py-10 px-6 sm:px-12 lg:px-24" id="contacto">
  <div class="absolute inset-0 bg-gradient-to-br from-blue-50 to-white z-0"></div>
  <div class="relative z-10 max-w-6xl mx-auto">
    <div class="text-center mb-16">
      <h2 class="text-4xl font-extrabold text-dark">Contáctanos</h2>
      <p class="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">En Codijobs valoramos la comunicación. Si eres candidato, empresa o colaborador, estamos disponibles para ayudarte. Déjanos tu mensaje y pronto estaremos en contacto.</p>
    </div>
    <div class="grid grid-cols-[35%_65%] gap-1 bg-white rounded-2xl overflow-hidden p-2">
      <div class="bg-dark rounded-xl text-white p-12 flex flex-col  ">
        <div>
          <h3 class="text-2xl font-bold mb-6 space-y-10">Conéctate con nosotros</h3>
          <ul class="space-y-10 text-base">
            <li class="flex items-center text-white text-base">
              <ng-icon name="ionLocationOutline" size="25" class="mr-2"></ng-icon>
              Av. Los Chankas 143.
            </li>
            <li class="flex items-center text-white text-base">
              <ng-icon name="bootstrapEnvelope" size="25" class="mr-2"></ng-icon>
              contac&#64;codijobs.com
            </li>
            <li class="flex items-center text-white text-base">
              <ng-icon name="bootstrapTelephone" size="25" class="mr-2"></ng-icon>
              +51 956 248 003
            </li>
          </ul>
        </div>
        <div class="mt-10 ">
          <p class="text-sm opacity-80">Síguenos en nuestras redes:</p>
          <div class="flex mt-4 space-x-4">
            <a href="#" class="hover:text-white text-white/80 transition"><svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22.46 6c-.77.35-1.6.59-2.46.69a4.28 4.28 0 001.88-2.37 8.48 8.48 0 01-2.7 1.03 4.24 4.24 0 00-7.22 3.87A12.01 12.01 0 013 5.16a4.22 4.22 0 001.31 5.65A4.2 4.2 0 012.8 10v.05a4.24 4.24 0 003.4 4.15 4.23 4.23 0 01-1.9.07 4.25 4.25 0 003.96 2.94A8.5 8.5 0 012 19.54a12.03 12.03 0 006.29 1.84c7.55 0 11.68-6.26 11.68-11.68 0-.18 0-.36-.01-.54A8.32 8.32 0 0022.46 6z"/></svg></a>
            <a href="#" class="hover:text-white text-white/80 transition"><svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.6 3H4.4C3.6 3 3 3.6 3 4.4v15.2c0 .8.6 1.4 1.4 1.4h15.2c.8 0 1.4-.6 1.4-1.4V4.4c0-.8-.6-1.4-1.4-1.4zM8.4 19H5.8V9.8h2.6V19zm-1.3-10.3c-.9 0-1.5-.6-1.5-1.4 0-.8.6-1.4 1.4-1.4s1.5.6 1.5 1.4c0 .8-.6 1.4-1.4 1.4zm12.3 10.3h-2.6v-4.5c0-1.1-.4-1.8-1.4-1.8-.8 0-1.2.5-1.4 1-.1.2-.1.5-.1.7V19h-2.6s.1-8.5 0-9.2h2.6v1.3c.3-.5 1-1.3 2.4-1.3 1.8 0 3.1 1.2 3.1 3.9V19z"/></svg></a>
          </div>
        </div>
      </div>
      <div class="p-10 bg-white">
        <form action="#" method="POST" class="space-y-6">
          <div class="flex space-x-6">
            <div class="flex-1">
              <label class="block text-sm font-medium-light text-gray-700 mb-1">Nombre</label>
              <input type="text" name="nombre" class="w-full border-b-2 border-gray-300 focus:border-blue-950 focus:outline-none py-2"/>
            </div>
            <div class="flex-1">
              <label class="block text-sm font-medium-light text-gray-700 mb-1">Correo electrónico</label>
              <input type="email" name="email" class="w-full border-b-2 border-gray-300 focus:border-blue-950 focus:outline-none py-2"/>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium-light text-gray-700 mb-1">Asunto</label>
            <input type="text" name="asunto" class="w-full border-b-2 border-gray-300 focus:border-blue-950 focus:outline-none py-2"/>
          </div>
          <div>
            <label class="block text-sm font-medium-light text-gray-700 mb-1">Mensaje</label>
            <textarea name="mensaje" rows="5" class="w-full border-b-2 border-gray-300 focus:border-blue-950 focus:outline-none py-2 resize-none"></textarea>
          </div>
          <div class="flex justify-center">
            <button type="submit" class="w-auto py-3 px-6 bg-blue-950 text-white font-semibold rounded-md shadow-md hover:bg-blue-900 transition focus:outline-none focus:ring-2 focus:bg-primary">
              Enviar mensaje
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
